import type { TradeLogicRegistrySchemaFieldDto } from '../registry';

const ENTRY_TEMPLATE_DEFAULTS: Record<string, string> = {
    priority: '100',
    quantity: '1'
};

export const hasEntryActionTemplateDefaults = (fields: TradeLogicRegistrySchemaFieldDto[]): boolean =>
    fields.some((field) => ENTRY_TEMPLATE_DEFAULTS[field.key] !== undefined);

export const buildEntryActionTemplateDefaultValues = (
    fields: TradeLogicRegistrySchemaFieldDto[],
    currentValues: Record<string, string>
): Record<string, string> => {
    const fieldKeys = new Set(fields.map((field) => field.key));
    const nextValues = { ...currentValues };

    for (const [key, defaultValue] of Object.entries(ENTRY_TEMPLATE_DEFAULTS)) {
        if (fieldKeys.has(key) && (nextValues[key] ?? '').trim() === '') {
            nextValues[key] = defaultValue;
        }
    }

    return nextValues;
};
